import delimiter from './delimiter';

function formatCurrency(currency) {
  const symbols = {
    idr: 'Rp',
    usd: '$',
  };

  return symbols[currency.toLowerCase()] || currency;
}

export default function money(val, precision = 0, currency = 'Rp') {
  const int = delimiter(Number(val) || 0, precision);
  if (int.charAt(0) === '-') {
    return int.replace(/^-/g, `-${formatCurrency(currency)}`);
  }
  return `${formatCurrency(currency)}${int}`;
}
